import { Capacitor } from '@capacitor/core';
import nativeConfig from '../../native.config.json';

export const SERVER_URL = Capacitor.isNativePlatform()
  ? nativeConfig.serverUrl.replace(/\/$/, '')
  : window.location.origin;
